export default "__VITE_ASSET__d9827bd4__"